import React, { memo } from 'react'
import styled from 'styled-components'
import { Spacings, Text, Devices } from '@styles'

export const CardV2 = styled.div`
	background: ${({ theme }) => theme.colors.surface.card};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.lg};
	padding: ${({ padding }) => padding || Spacings.SPACING_4B};
	display: flex;
	flex-direction: column;
	gap: ${({ gap }) => gap || Spacings.SPACING_3B};
	box-shadow: ${({ theme }) => theme.shadows.sm};
	transition: all 0.2s ease-in-out;
	font-family: ${({ theme }) => theme.fontFamily.inter};

	&:hover {
		${({ hoverable = true, theme }) =>
			hoverable &&
			`
			// border-color: ${theme.colors.border.focus};
			box-shadow: ${theme.shadows.md};
		`}
	}

	@media ${Devices.tablet} {
		padding: ${({ tabletPadding, padding }) => tabletPadding || padding || Spacings.SPACING_4B};
		gap: ${({ tabletGap, gap }) => tabletGap || gap || Spacings.SPACING_3B};
	}
`

const CardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: ${Spacings.SPACING_2B};
	border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
	padding-bottom: ${Spacings.SPACING_2B};
`

const CardTitle = styled.h4`
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_700};
	color: ${({ theme }) => theme.colors.text.primary};
	margin: 0;
`

const CardActions = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_1B};
`

const CardBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
`

const CardInfoRow = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};
`

const CardInfoLabel = styled.span`
	font-size: ${Text.EXTRA_SMALL};
	color: ${({ theme }) => theme.colors.text.secondary};
	font-weight: ${Text.BOLD_600};
	text-transform: uppercase;
	letter-spacing: 0.025em;
`

const CardInfoValue = styled.span`
	font-size: ${Text.SMALL};
	color: ${({ theme }) => theme.colors.text.primary};
	font-weight: ${Text.BOLD_500};
`

const CardMetrics = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_3B};
	margin-top: ${Spacings.SPACING_1B};
	background: ${({ theme }) => theme.colors.surface.overlay};
	padding: ${Spacings.SPACING_2B};
	border-radius: ${({ theme }) => theme.radius.md};
`

const CardMetricItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};
`

const CardComponent = memo(({ children, ...props }) => {
	return <CardV2 {...props}>{children}</CardV2>
})

CardComponent.Header = CardHeader
CardComponent.Title = CardTitle
CardComponent.Actions = CardActions
CardComponent.Body = CardBody
CardComponent.InfoRow = CardInfoRow
CardComponent.InfoLabel = CardInfoLabel
CardComponent.InfoValue = CardInfoValue
CardComponent.Metrics = CardMetrics
CardComponent.MetricItem = CardMetricItem

export default CardComponent
